export const WEDDING_EVENT = {
  title: "Yisehak & Lydia's Wedding",
  // Sept 19 2026, 6:00 PM - 11:00 PM EAT (UTC+3) expressed in UTC.
  startUtc: '20260919T150000Z',
  endUtc: '20260919T200000Z',
  location: 'Ethiopia Hotel No. 2 (Old Global Hotel), Lancha, Addis Ababa, Ethiopia',
  description:
    "Join us as we celebrate the wedding of Yisehak & Lydia. Festivities from 6 PM onwards.",
  mapUrl: 'https://maps.app.goo.gl/BvLFyp5nyGEgoz9k8?g_st=ac',
};

// Placeholder day-of schedule shown until the real Google Calendar sync
// (netlify/functions/get-schedule.js) lands. Same field shape that function
// returns, so TimelineScreen never has to branch on where the data came from.
export const FALLBACK_SCHEDULE = [
  {
    id: 'ceremony',
    title: 'Ceremony',
    startUtc: '20260919T150000Z',
    endUtc: '20260919T160000Z',
    location: WEDDING_EVENT.location,
  },
  {
    id: 'cocktail-hour',
    title: 'Cocktail Hour',
    startUtc: '20260919T160000Z',
    endUtc: '20260919T170000Z',
    location: WEDDING_EVENT.location,
  },
  {
    id: 'reception',
    title: 'Reception & Dinner',
    startUtc: '20260919T170000Z',
    endUtc: '20260919T200000Z',
    location: WEDDING_EVENT.location,
  },
];

export function getGoogleCalendarUrl() {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: WEDDING_EVENT.title,
    dates: `${WEDDING_EVENT.startUtc}/${WEDDING_EVENT.endUtc}`,
    location: WEDDING_EVENT.location,
    details: WEDDING_EVENT.description,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

function buildIcs() {
  const dtStamp = new Date()
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}/, '');
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//WeddingApp//EN',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    'UID:yisehak-lydia-wedding-2026-09-19@weddingapp',
    `DTSTAMP:${dtStamp}`,
    `DTSTART:${WEDDING_EVENT.startUtc}`,
    `DTEND:${WEDDING_EVENT.endUtc}`,
    `SUMMARY:${WEDDING_EVENT.title}`,
    `LOCATION:${WEDDING_EVENT.location}`,
    `DESCRIPTION:${WEDDING_EVENT.description}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
}

export function downloadIcs() {
  const blob = new Blob([buildIcs()], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'yisehak-lydia-wedding.ics';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
